import React from 'react';
import styled from 'styled-components';
import ErrorPage from './ErrorPageView';

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const { ADV } = window;

const editFinancialPlan = (clientId: any) => {
  const routeObj = ADV.util.Router.getObjFromHash(`editplan/${clientId}`);
  if (!routeObj) {
    throw new Error('[MissingInfo]: The route is incorrect');
  }
  ADV.util.Router.go2(routeObj.id, routeObj.params);
};

interface MissingInfoProps{
  errors: Array<string>,
  clientId: any,
}

const MissingInfo = ({ errors, clientId } : MissingInfoProps) => {
  const buttonData = () => {
    if (ADV.entities.isOptedIn('EditFinancialPlan')) {
      return {
        text: 'Edit Financial Plan',
        onClick: () => editFinancialPlan(clientId),
      };
    }
    return {};
  };

  return (
    <ErrorPage
      icon="fas fa-flag"
      title="Some information is missing."
      message={
        <List>
          {(errors || []).map(error => (
            <li key={error}>{error}</li>
          ))}
        </List>
      }
      button={buttonData()}
    />
  );
};

export default MissingInfo;
